<mat-card class="cardWithShadow">
  <mat-card-content>
    @if( invoice()) {
    <span>
      <form #invoiceForm="ngForm">
        <div class="row m-b-24">
          <div class="col-sm-4 d-flex align-items-center">
            <h4 class="f-s-14 f-s-18 f-w-600">
              #
              <span name="id" [(ngModel)]="invoice().id" ngDefaultControl>
                {{ invoice().id }}</span
              >
            </h4>
          </div>
          <div class="col-sm-8 text-right">
            <a
              routerLink="/apps/invoice"
              mat-flat-button
              class="bg-error text-white m-r-10"
            >
              Cancel
            </a>

            <button
              mat-flat-button
              color="primary"
              (click)="saveDetail($event)"
            >
              Save Invoice
            </button>
          </div>
        </div>

        <mat-divider></mat-divider>

        <div class="row p-y-24 justify-content-between">
          <div class="col-sm-4">
            <span class="f-w-600 f-s-15 d-block m-b-8"> Order Status: </span>
            <mat-form-field appearance="outline" class="w-100 theme-select">
              <mat-select name="satus" [(ngModel)]="invoice().status">
                <mat-option value="Pending"> Pending </mat-option>
                <mat-option value="Shipped"> Shipped </mat-option>
                <mat-option value="Delivered"> Delivered </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-sm-6 d-flex align-items-center justify-content-end">
            <div class="text-right">
              <span class="f-w-600 f-s-15 d-block m-b-8"> Order Date </span>
              <h6
                name="date"
                class="m-t-5 m-b-0 f-w-500 f-s-14 f-s-16"
                [(ngModel)]="invoice().orderDate"
                ngDefaultControl
              >
                {{ invoice().orderDate | date : "dd-MM-yyyy" }}
              </h6>
            </div>
          </div>
        </div>

        <mat-divider></mat-divider>

        <div class="row m-y-24 p-t-24">
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Bill From</mat-label>
              <input
                matInput
                placeholder="Bill From"
                name="from"
                [(ngModel)]="invoice().billFrom"
              />
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Bill To</mat-label>
              <input
                matInput
                placeholder="Bill To"
                name="to"
                [(ngModel)]="invoice().billTo"
              />
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Enter From Address</mat-label>
              <input
                matInput
                placeholder="Enter From Address"
                name="fromAddress"
                [(ngModel)]="invoice().billFromAddress"
              />
            </mat-form-field>
          </div>
          <div class="col-sm-6">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Bill From</mat-label>
              <input
                matInput
                placeholder="Enter To Address"
                name="toAddress"
                [(ngModel)]="invoice().billToAddress"
              />
            </mat-form-field>
          </div>
        </div>
      </form>
    </span>
    }

    <form [formGroup]="addForm" class="edit-invoice-list">
      <div class="table-responsive">
        <table
          id="tblAdd"
          class="table table-hover b-1 no-wrap w-100 rounded text-left"
        >
          <thead>
            <tr>
              <th class="p-16">#</th>
              <th class="p-16">Item Name</th>
              <th class="p-16">Unit Price</th>
              <th class="p-16">Units</th>
              <th class="p-16">Unit Total Price</th>
              <th class="p-16"></th>
            </tr>
          </thead>

          @for(a of addForm.get('item')['controls']; track a; let i =$index) {
          <tbody formArrayName="item">
            <tr [formGroupName]="i">
              <td class="p-16">
                {{ i + 1 }}
              </td>
              <td class="p-16">
                <mat-form-field appearance="outline" class="w-100 hide-hint">
                  <input
                    matInput
                    type="text"
                    [id]="'txtNameControl' + i"
                    class="form-control"
                    placeholder="Enter Item Name"
                    formControlName="itemName"
                    (input)="itemsChanged()"
                  />
                </mat-form-field>
              </td>
              <td class="p-16">
                <mat-form-field appearance="outline" class="w-100 hide-hint">
                  <input
                    matInput
                    type="number"
                    [id]="'txtCostControl' + i"
                    class="form-control"
                    placeholder="Enter Item Price"
                    formControlName="itemCost"
                    (input)="itemsChanged()"
                  />
                </mat-form-field>
              </td>
              <td class="p-16">
                <mat-form-field appearance="outline" class="w-100 hide-hint">
                  <input
                    matInput
                    type="number"
                    [id]="'txtTotalControl' + i"
                    class="form-control"
                    placeholder="Enter Item"
                    formControlName="itemSold"
                    (input)="itemsChanged()"
                  />
                </mat-form-field>
              </td>
              <td class="p-16">
                <mat-form-field appearance="outline" class="w-100 hide-hint">
                  <input
                    matInput
                    type="number"
                    formControlName="itemTotal"
                    [id]="'txtitemTotalControl' + i"
                    [value]="
                      (addForm.get('item')?.value[i]?.itemCost || 0) *
                      (addForm.get('item')?.value[i]?.itemSold || 0)
                    "
                    class="form-control"
                    [disabled]="true"
                  />
                </mat-form-field>
              </td>
              <td>
                <button
                  mat-icon-button
                  color="primary"
                  (click)="btnAddItemClick()"
                  class="d-flex justify-content-center icon-38 p-8"
                  [disabled]="addForm.get('item')?.invalid"
                >
                  <i-tabler
                    name="circle-plus"
                    class="icon-18 d-flex"
                  ></i-tabler>
                </button>
              </td>
              <td>
                @if(addForm.get('item')?.length > 1) {
                <button
                  mat-icon-button
                  (click)="btnRemoveClick(i)"
                  class="d-flex justify-content-center icon-38 p-8"
                >
                  <i-tabler name="trash" class="icon-18 d-flex"></i-tabler>
                </button>
                }
              </td>
            </tr>
          </tbody>
          }
        </table>
      </div>

      <div class="text-right m-t-30">
        <div class="text-right m-t-30">
          @if(addForm.get('rows')) {
          <button color="accent" mat-flat-button [disabled]="addForm.invalid">
            Add row
          </button>
          }

          <h5 class="m-b-5 f-w-600 f-s-16">Sub total: {{ subTotal() }}</h5>
          <h5 class="f-w-600 f-s-16 m-b-24">Total Vat: {{ vat() }}%</h5>
          <mat-divider></mat-divider>
          <h3 class="m-b-0 p-t-20 f-s-18">Grand Total: {{ grandTotal() }}</h3>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
